import { render, staticRenderFns } from "./ingoods.vue?vue&type=template&id=6b9356e8&scoped=true"
import script from "./ingoods.vue?vue&type=script&lang=js"
export * from "./ingoods.vue?vue&type=script&lang=js"
import style0 from "./ingoods.vue?vue&type=style&index=0&id=6b9356e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9356e8",
  null
  
)

export default component.exports